import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Stack } from "@mui/material";

import Logo from "../Logo/Logo";
import GreetingAndMenu from "../GreetingAndMenu/GreetingAndMenu";

import StopInvestigationModal from "../../UI/StopInvestigationDialog/StopInvestigationDialog";
import ConfirmationDialog from "../../UI/ConfirmationDialog/ConfirmationDialog";
import FooterBarcode from "../FooterBarcode/FooterBarcode";

const MissionsFooter = () => {
  const navigate = useNavigate();
  const [isConfirmedOpen, setIsConfirmedOpen] = useState(false);
  const [openStopInvestigation, setOpenStopInvestigation] = useState(false);

  const handleExit = () => navigate("/map");
  const handleConfirm = () => setIsConfirmedOpen(true);
  const handleConfirmationClose = () => setIsConfirmedOpen(false);
  const handleClose = () => setOpenStopInvestigation(!openStopInvestigation);

  return (
    <Stack direction={"row"} className="container footer">
      <Logo />

      <GreetingAndMenu
        isPlaying={true}
        handleExit={() => setOpenStopInvestigation(true)}
      />
      <FooterBarcode />
      <StopInvestigationModal
        open={openStopInvestigation}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
      <ConfirmationDialog
        open={isConfirmedOpen}
        handleConfirmation={handleExit}
        onClose={handleConfirmationClose}
      />
    </Stack>
  );
};
export default MissionsFooter;
